import { DocumentNode, OperationVariables, QueryHookOptions, useQuery } from '@apollo/client';
import { head } from 'lodash/fp';

import uniqueContentWithDraftPrecedence from '../../../../cms/utils/unique-content-with-draft-precedence';
import type { CmsInsuranceTypeContent } from '../../types';

type InsuranceTypeQueryResult = {
  data: CmsInsuranceTypeContent;
  loading: boolean;
};

const useInsuranceTypeQuery = (
  gqlQuery: DocumentNode,
  options: QueryHookOptions<any, OperationVariables>,
): InsuranceTypeQueryResult => {
  const { data, loading } = useQuery(gqlQuery, options);
  const content = head(uniqueContentWithDraftPrecedence(data?.allInsuranceType)) as CmsInsuranceTypeContent;
  return { data: content, loading };
};

export default useInsuranceTypeQuery;
